import { SportConfigExport } from './';
import {
	$t,
	getCompetitorsParams,
	singleStepCompetition,
	singleStepEvent,
	singleStepOverview,
	singleStepTeam,
} from './singleStepContexts';

import { SingleStepSportEvent, SportType } from '@/@types/graphql-types';
import { WebLocale } from '@/enums/web-locale';
import { SportPageType } from '@/features/sports/types/interfaces';

/* CONSTANTS */
const sportName = $t('SPORTS_WEBAPP_SPORT_TYPE_BASKETBALL');
const switchedLocales = [WebLocale.us, WebLocale.ca, WebLocale.uk];

function getCompetitors(event: SingleStepSportEvent, webLocale: WebLocale) {
	return getCompetitorsParams(event, switchedLocales.includes(webLocale));
}

/* CONTEXTS */
function overview() {
	const { getEventTitleParams, ...rest } = singleStepOverview(SportType.Basketball);

	function getEventTitle(event: SingleStepSportEvent, webLocale: WebLocale) {
		return getEventTitleParams(event, switchedLocales.includes(webLocale));
	}

	return {
		sportName,
		getEventTitle,
		headline: $t('SPORTS_WEBAPP_OVERVIEW_HEADLINE_BASKETBALL'),
		subheading: $t('SPORTS_WEBAPP_OVERVIEW_TEXT_BASKETBALL'),
		getCompetitors,
		...singleStepOverview(SportType.Basketball),
		...rest,
	};
}

function competition() {
	const { getEventTitleParams, ...rest } = singleStepCompetition(SportType.Basketball);

	function getEventTitle(event: SingleStepSportEvent, webLocale: WebLocale) {
		return getEventTitleParams(event, switchedLocales.includes(webLocale));
	}

	return {
		sportName,
		getEventTitle,
		getCompetitors,
		...singleStepCompetition(SportType.Basketball),
		...rest,
	};
}

function event() {
	const { getEventTitleParams, ...rest } = singleStepEvent(SportType.Basketball);

	function getEventTitle(event: SingleStepSportEvent, webLocale: WebLocale) {
		return getEventTitleParams(event, switchedLocales.includes(webLocale));
	}

	return {
		sportName,
		getEventTitle,
		getCompetitors,
		...rest,
	};
}

function team() {
	const { getEventTitleParams, ...rest } = singleStepTeam(SportType.Basketball);

	function getEventTitle(event: SingleStepSportEvent, webLocale: WebLocale) {
		return getEventTitleParams(event, switchedLocales.includes(webLocale));
	}

	return {
		sportName,
		getEventTitle,
		getCompetitors,
		...rest,
	};
}

/* EXPORTS */
const config: SportConfigExport = {
	[SportPageType.SportOverview]: overview,
	[SportPageType.SportCompetition]: competition,
	[SportPageType.SportEvent]: event,
	[SportPageType.SportTeam]: team,
};

export default config;
